// extracted by mini-css-extract-plugin
module.exports = {"disable-modal":"AdminPanel_disable-modal__3ocFl"};